document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.popup-trigger');
  if (!trigger) return;

  e.preventDefault();

  const popupModal = document.getElementById('content-popup');
  if (!popupModal) return;

  const popupOverlay = popupModal.querySelector('.popup-overlay');
  const popupCloseBtn = popupModal.querySelector('.popup-close');
  const popupCloseBtn2 = popupModal.querySelector('.popup-close-btn');
  const popupTitle = popupModal.querySelector('.popup-title');
  const popupBody = popupModal.querySelector('.popup-body');

  // const url = trigger.dataset.url;
  // const title = trigger.dataset.title;
  // const type = trigger.dataset.type;
  
const title = trigger.dataset.title;
const url = trigger.dataset.url;
let type = "link";

// Remove query params and lowercase
const cleanUrl = url.split("?")[0].toLowerCase();

// Extract extension safely
const extension = cleanUrl.substring(cleanUrl.lastIndexOf(".") + 1);

if (extension === "pdf") {
  type = "pdf";
} else if (extension === "mp4" || extension === "mov") {
  type = "video";
} else if (
  extension === "jpg" ||
  extension === "jpeg" ||
  extension === "png"
) {
  type = "image";
}


  console.log("url is ",url)
  console.log("type is ", type)

  popupTitle.textContent = title || '';
  popupBody.innerHTML = '';


  if (type === 'pdf') {
    popupBody.innerHTML = `<iframe src="${url}" loading="lazy"></iframe>`;
   
  } 
  else if (type === 'video') {
    popupBody.innerHTML = `
      <video controls>
        <source src="${url}" type="video/mp4">
      </video>`;
      
   
  } 
  else if (type === 'image') {
    popupBody.innerHTML = `<img src="${url}" alt="${title}">`;
   
  }
  // else{
  //    <p class="error">Error!</p>

  // }



  popupModal.style.display = 'block';
  document.body.style.overflow = 'hidden';

 
  const closePopup = () => {
    popupModal.style.display = 'none';
    popupBody.innerHTML = '';
  
    document.body.style.overflow = '';
  };

  popupOverlay?.addEventListener('click', closePopup, { once: true });
  popupCloseBtn?.addEventListener('click', closePopup, { once: true });
  popupCloseBtn2?.addEventListener('click', closePopup, { once: true });

  document.addEventListener('keydown', function escHandler(ev) {
    if (ev.key === 'Escape') {
      closePopup();
      document.removeEventListener('keydown', escHandler);
    }
  });
});
